export default __webpack_public_path__ + "static/frn-logo-2019-18f806b4.svg";